import React from 'react';

const YouTubePlayer = ({ videoSection }) => {
  const extractYouTubeVideoId = (url) => {
    if (!url) return null;

    try {
      const regex = /(?:youtube\.com\/(?:[^/]+\/[^/]+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
      const match = url.match(regex);
      return match ? match[1] : null;
    } catch (error) {
      console.error('Error extracting YouTube video ID:', error);
      return null;
    }
  };

  // Validate videoSection and url
  if (!videoSection?.url) {
    return null;
  }

  const videoId = extractYouTubeVideoId(videoSection.url);

  if (!videoId) {
    return null;
  }

  return (
    <div className="video-wrapper">
      <iframe
        className="youtube-video"
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube Video Player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default YouTubePlayer;
